import { Container, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import SMButton from "../config/components/SMButton";
import MainLayout from "../config/mainlayout";

function Home() {
  return (
    <>
      <MainLayout />
    </>
  );
}
export default Home;
